import { useEffect } from "react";
import api from "../utils/api";

// Bir token için sayfa ömrü boyunca bir kez: kullanıcının lokasyonu açık
// kanallarının bugün + dün verisini sunucu arka planda hazırlamaya başlar.
const requestedTokens = new Set();

export function useLocationPreload(user) {
  useEffect(() => {
    if (!user) return;

    const items = (user.sidebaritems || []).map((s) => String(s).toLowerCase());
    if (!items.includes("location")) return;

    const token = localStorage.getItem("adm_panel_token");
    if (!token || requestedTokens.has(token)) return;
    requestedTokens.add(token);

    api.post("/location/preload").catch(() => {});
  }, [user]);
}
